import React, { Component } from 'react'
import { withTheme, withStyles } from 'material-ui/styles'
import _ from 'lodash'
import { IconButton, ToolbarGroup } from 'material-ui-effco'
import FilterIcon from 'mdi-material-ui/Filter'
import ExportXLSXIcon from 'mdi-material-ui/FileExcelBox'
import ExportPDFIcon from 'mdi-material-ui/FilePdfBox'
import SwitchViewIcon from 'mdi-material-ui/ViewCarousel'

import Chip from 'material-ui/Chip'
import Tooltip from 'material-ui/Tooltip'

const styles = theme => ({
  chip: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    margin: theme.spacing.unit / 2,
    marginTop: 10,
    // fontWeight: 'bold'
    maxWidth: 150,
    justifyContent: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  chipLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block'
  },
  tooltip: {
    fontSize: '0.85rem',
    padding: '8px 16px'
  }
})

class ToolbarOptions extends Component {
  handleDelete = (chip, filters) => {
    const { changeFilters } = this.props

    const filtersAdjusted = _.reject(filters, ['columnName', chip.columnName])

    changeFilters(filtersAdjusted)
  }

  render() {
    const styles = {
      btnupl: {
        marginTop: 3,
        float: 'right'
      }
    }
    const {
      theme: { palette },
      updateViewURL,
      searchToggle,
      getSelection,
      isSelection,
      filters,
      columns,
      classes
    } = this.props

    const chipData = _.sortBy(filters, ['columnName']).map(e => ({
      ...e,
      title: _.get(_.find(columns, ['name', e.columnName]), 'title')
    }))

    return (
      <ToolbarGroup>
        {chipData.map((chip, i) => {
          let label = chip.label || chip.value
          label = `${chip.title}: ${
            _.isArray(label) ? label.join(', ') : label
          }`
          return (
            <Tooltip
              key={`chipTooltip-${i}`}
              id={`chipTooltip-${i}`}
              title={label}
              placement="bottom-end"
              classes={{ tooltip: classes.tooltip }}
            >
              <Chip
                key={chip.columnName}
                label={label}
                onClick={() => this.handleDelete(chip, filters)}
                className={classes.chip}
                classes={{ label: classes.chipLabel }}
              />
            </Tooltip>
          )
        })}
        <IconButton
          tooltip="Data Filter"
          tooltipPosition="bottom-left"
          touch
          style={{ ...styles.btnupl }}
          onTouchTap={searchToggle}
          iconStyle={{ color: palette.primary.main }}
        >
          <FilterIcon />
        </IconButton>
        {isSelection && (
          <div>
            <IconButton
              disabled
              tooltip="Export to PDF"
              tooltipPosition="bottom-left"
              touch
              style={{ ...styles.btnupl }}
              containerElement="label"
              // onTouchTap={getSelection}
              iconStyle={{ color: palette.primary.main }}
            >
              <ExportPDFIcon />
            </IconButton>
            <IconButton
              tooltip="Export to Excel"
              tooltipPosition="bottom-left"
              touch
              disabled={false}
              style={{ ...styles.btnupl }}
              containerElement="label"
              onTouchTap={getSelection}
              iconStyle={{ color: palette.primary.main }}
            >
              <ExportXLSXIcon />
            </IconButton>
          </div>
        )}
        <IconButton
          tooltip="Switch View"
          tooltipPosition="bottom-left"
          touch
          style={styles.btnupl}
          onTouchTap={updateViewURL}
          iconStyle={{ color: palette.primary.main }}
        >
          <SwitchViewIcon />
        </IconButton>
      </ToolbarGroup>
    )
  }
}

export default withStyles(styles)(withTheme()(ToolbarOptions))



// WEBPACK FOOTER //
// ./src/common/components/ToolbarOptions.js